(function() { window.GUID_07dde89f_4a48_4f13_912d_0e8c436af3c1 = { getGuid: function() { return "07dde89f-4a48-4f13-912d-0e8c436af3c1"; } }; })();
var CompuSport;
(function (CompuSport) {
    var UI;
    (function (UI) {
        class Blinker {
            constructor(element) {
                this.alreadyBlinking = false;
                //if (element.data('blink'))
                //    return;
                //element.data('blink', true)
                this.elementToBlink = element;
                this.elementToBlink.addClass('notransition');
                this.originalParameter = element.css(['color', 'backgroundColor', 'opacity']);
            }
            BlinkElement(nbTimes, blinkParameter, blinkParameterOffSet) {
                if (this.alreadyBlinking) {
                    return;
                }
                this.blinkParameter = blinkParameter == null ? { css: { opacity: 0.25 }, duration: 400 } : blinkParameter;
                this.blinkParameterOffSet = blinkParameterOffSet == null ? { css: { opacity: 1 }, duration: 400 } : blinkParameterOffSet;
                this._blinkElement(nbTimes);
            }
            _blinkElement(nbTimes) {
                let me = this;
                if (nbTimes == 0) {
                    me.alreadyBlinking = false;
                    this.elementToBlink.removeClass('notransition');
                    me.elementToBlink.animate(me.originalParameter, me.blinkParameter.duration);
                    return;
                }
                me.alreadyBlinking = true;
                me.elementToBlink.animate(me.blinkParameter.css, me.blinkParameter.duration, "linear", function () {
                    me.elementToBlink.animate(me.blinkParameterOffSet.css, me.blinkParameterOffSet.duration, function () {
                        me._blinkElement(nbTimes - 1);
                    });
                });
            }
        }
        UI.Blinker = Blinker;
    })(UI = CompuSport.UI || (CompuSport.UI = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Blinker.js.map
